import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React, { useRef, useState } from 'react';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import classNames from 'classnames';
import useClickOutside from 'hooks/useClickOutside';
import styles from './PlusAccordion.module.scss';

const PlusAccordion = ({
  activeItemLabel,
  activeItem,
  hiddenItems,
}: {
  activeItemLabel: string;
  activeItem: JSX.Element;
  hiddenItems: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  useClickOutside(containerRef, () => {
    setIsOpen(false);
  });

  const activeIcon = isOpen ? 'dropdown-arrow-up' : 'dropdown-arrow-down';

  const handleItemClick = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <div className={`${styles.container} ${isOpen ? styles.open : ''}`} ref={containerRef}>
      <div
        className={classNames(styles.item, {
          [styles.active]: isOpen,
        })}
        onClick={handleItemClick}
      >
        {activeItem}
        <div
          className={classNames(styles.header, {
            [styles.active]: isOpen,
          })}
          onClick={handleClick}
        >
          <OpText variant="title-small-regular">{activeItemLabel}</OpText>
          <OpIcon icon={activeIcon} size="small" />
        </div>
      </div>

      {isOpen && <div className={styles.dropdownContent}>{hiddenItems}</div>}
    </div>
  );
};

export default PlusAccordion;
